

export const LICENSE_TYPE_OPTIONS = [
  { id: "C", value: "C", label: "C" },
  { id: "C_M", value: "C:M", label: "C:M" },
  { id: "CDL_A", value: "CDL_A", label: "CDL_A" },
  { id: "CDL_A_M", value: "CDL_A:M", label: "CDL_A:M" },
  { id: "CDL_B", value: "CDL_B", label: "CDL_B" },
  { id: "CDL_B_M", value: "CDL_B:M", label: "CDL_B:M" },
  { id: "CDL_C", value: "CDL_C", label: "CDL_C" },
  { id: "CDL_C_M", value: "CDL_C:M", label: "CDL_C:M" },
  { id: "D", value: "D", label: "D" },
  { id: "D_M", value: "D:M", label: "D:M" },
  { id: "D_CONDITIONAL", value: "D_CONDITIONAL", label: "D_CONDITIONAL" },
  { id: "D_RESTRICTED", value: "D_RESTRICTED", label: "D_RESTRICTED" },
  { id: "E", value: "E", label: "E" },
  { id: "E_M", value: "E:M", label: "E:M" },
  { id: "NA", value: "NA", label: "NA" },
  { id: "OUT_OF_STATE", value: "OUT OF STATE", label: "OUT OF STATE" },
  { id: "PERMIT", value: "PERMIT", label: "PERMIT" }
];

export const LICENSE_STATE_OPTIONS = [
  { id: "AL", value: "AL", label: "AL" },
  { id: "AK", value: "AK", label: "AK" },
  { id: "AZ", value: "AZ", label: "AZ" },
  { id: "AR", value: "AR", label: "AR" },
  { id: "CA", value: "CA", label: "CA" },
  { id: "CO", value: "CO", label: "CO" },
  { id: "CT", value: "CT", label: "CT" },
  { id: "DE", value: "DE", label: "DE" },
  { id: "DC", value: "DC", label: "DC" },
  { id: "FL", value: "FL", label: "FL" },
  { id: "GA", value: "GA", label: "GA" },
  { id: "HI", value: "HI", label: "HI" },
  { id: "ID", value: "ID", label: "ID" },
  { id: "IL", value: "IL", label: "IL" },
  { id: "IN", value: "IN", label: "IN" },
  { id: "IA", value: "IA", label: "IA" },
  { id: "KS", value: "KS", label: "KS" },
  { id: "KY", value: "KY", label: "KY" },
  { id: "LA", value: "LA", label: "LA" },
  { id: "ME", value: "ME", label: "ME" },
  { id: "MD", value: "MD", label: "MD" },
  { id: "MA", value: "MA", label: "MA" },
  { id: "MI", value: "MI", label: "MI" },
  { id: "MN", value: "MN", label: "MN" },
  { id: "MS", value: "MS", label: "MS" },
  { id: "MO", value: "MO", label: "MO" },
  { id: "MT", value: "MT", label: "MT" },
  { id: "NE", value: "NE", label: "NE" },
  { id: "NV", value: "NV", label: "NV" },
  { id: "NH", value: "NH", label: "NH" },
  { id: "NJ", value: "NJ", label: "NJ" },
  { id: "NM", value: "NM", label: "NM" },
  { id: "NY", value: "NY", label: "NY" },
  { id: "NC", value: "NC", label: "NC" },
  { id: "ND", value: "ND", label: "ND" },
  { id: "OH", value: "OH", label: "OH" },
  { id: "OK", value: "OK", label: "OK" },
  { id: "OR", value: "OR", label: "OR" },
  { id: "PA", value: "PA", label: "PA" },
  { id: "RI", value: "RI", label: "RI" },
  { id: "SC", value: "SC", label: "SC" },
  { id: "SD", value: "SD", label: "SD" },
  { id: "TN", value: "TN", label: "TN" },
  { id: "TX", value: "TX", label: "TX" },
  { id: "UT", value: "UT", label: "UT" },
  { id: "VT", value: "VT", label: "VT" },
  { id: "VA", value: "VA", label: "VA" },
  { id: "WA", value: "WA", label: "WA" },
  { id: "WV", value: "WV", label: "WV" },
  { id: "WI", value: "WI", label: "WI" },
  { id: "WY", value: "WY", label: "WY" }
];

export const LICENSE_STATUS_OPTIONS = [
  { id: "VALID", value: "VALID", label: "VALID" },
  { id: "SUSPENDED", value: "SUSPENDED", label: "SUSPENDED" },
  { id: "SURRENDERED", value: "SURRENDERED", label: "SURRENDERED" },
  { id: "REVOKED", value: "REVOKED", label: "REVOKED" },
  { id: "RESTRICTED", value: "RESTRICTED", label: "RESTRICTED" },
  { id: "PERMITS_ONLY", value: "PERMITS ONLY", label: "PERMITS ONLY" },
  { id: "PENDING_SUSPENSION", value: "PENDING SUSPENSION", label: "PENDING SUSPENSION" },
  { id: "PENDING_EXPIRE", value: "PENDING EXPIRE", label: "PENDING EXPIRE" },
  { id: "OUT_OF_STATE", value: "Out of State", label: "Out of State" },
  { id: "INVALID_DATA", value: "INVALID DATA", label: "INVALID DATA" },
  { id: "ID_ONLY", value: "ID ONLY", label: "ID ONLY" },
  { id: "EXPIRED", value: "EXPIRED", label: "EXPIRED" },
  { id: "CONDITIONAL", value: "CONDITIONAL", label: "CONDITIONAL" }
];